export default {
  computed: {
    isTemplatePublished() {
      return this.template.main && this.template.status === 'published'
    },

    mainIsPublished() {
      return !this.template.main
    },
  },
}
